import { useRoleText } from "@/hooks/use-role-text"
import { roleBadgeClassName, type RoleScope } from "@/lib/roles"
import { cn } from "@/lib/utils"

export type RoleBadgeProps = { scope: RoleScope; role: string; size?: "sm" | "md" | "lg"; className?: string }

// lg — ростом с RoleSelect: в шапке карточки неизменяемая роль стоит на месте селекта.
const SIZE_CLASS = {
  sm: "rounded-md px-1.5 py-px text-[10px] leading-[15px]",
  md: "rounded-md px-2 py-0.5 text-xs",
  lg: "h-8 rounded-lg px-2.5 text-[13px]",
} as const

export function RoleBadge({ scope, role, size = "sm", className }: RoleBadgeProps) {
  const roleText = useRoleText()

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center whitespace-nowrap",
        SIZE_CLASS[size],
        roleBadgeClassName(scope, role),
        className,
      )}
    >
      {roleText.label(scope, role)}
    </span>
  )
}
